module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loaderframe component",
    attrs: {
      "id": "contactFrameLoading"
    }
  }, [_c('div', {
    staticClass: "preloader loading"
  }, [_c('span', {
    staticClass: "slice"
  }), _vm._v(" "), _c('span', {
    staticClass: "slice"
  }), _vm._v(" "), _c('span', {
    staticClass: "slice"
  }), _vm._v(" "), _c('span', {
    staticClass: "slice"
  }), _vm._v(" "), _c('span', {
    staticClass: "slice"
  }), _vm._v(" "), _c('span', {
    staticClass: "slice"
  })]), _vm._v(" "), _c('p', [_vm._v("Gegevens ophalen...")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d389713"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/frontend/components/loader.vue
// module id = 112
// module chunks = 0